import React from "react";
import { Card, CopyButton, Text } from "@mantine/core";
import { JobListing } from "@lib/types/jobTypes";
import { Check, ExternalLink, Link, Mail } from "react-feather";
import BrandButton from "../Various/BrandButton";
import FatUnderlined from "../Various/FatUnderlined";
import Button from "../Various/Button";
import getJobUrl from "@lib/utils/url/getJobUrl";
import { useTranslation } from "next-i18next";

function GeneralInformation({
  job,
  sendApplication,
  hideActions,
  hasCustomApplicationLink,
}: {
  job: JobListing;
  sendApplication: () => void;
  hideActions?: boolean;
  hasCustomApplicationLink?: boolean;
}) {
  const { t } = useTranslation("joblisting");
  return (
    <Card.Section className="p-2">
      <div className="lg:flex justify-between">
        <Text
          size="xl"
          weight={500}
          className="text-3xl font-bold"
          component="h1"
        >
          <FatUnderlined>{job.title}</FatUnderlined>
        </Text>
      </div>

      {job.short_description && (
        <Text size="md" className="text-gray-600 font-medium mt-2">
          {job.short_description}
        </Text>
      )}

      {!hideActions && (
        <div className="flex flex-col md:grid md:grid-cols-4 mt-8 gap-6">
          <BrandButton
            onClick={sendApplication}
            className="col-span-2"
            data-test="apply-now"
          >
            <span className="flex items-center gap-5">
              {hasCustomApplicationLink ? (
                <ExternalLink size={15} />
              ) : (
                <Mail size={15} />
              )}

              <span>{t("applyOnline")}</span>
            </span>
          </BrandButton>

          {job.link && (
            <Button
              component="a"
              href={job.link}
              variant="subtle"
              target="_blank"
              rel="noreferrer"
            >
              <span className="flex items-center text-left gap-5">
                <span className="w-4">
                  <ExternalLink size={15} />
                </span>
                <span>{t("openCompanyPage")}</span>
              </span>
            </Button>
          )}

          <CopyButton value={getJobUrl(job)}>
            {({ copied, copy }) => (
              <Button
                block
                variant="subtle"
                onClick={copy}
                color={copied ? "teal" : "blue"}
              >
                <span className="flex items-center text-left gap-5">
                  {copied ? (
                    <Check size={25} className="text-green-500" />
                  ) : (
                    <>
                      <span className="w-4">
                        <Link size={15} />
                      </span>
                      <span>{t("copyLinkToJob")}</span>
                    </>
                  )}
                </span>
              </Button>
            )}
          </CopyButton>
        </div>
      )}
    </Card.Section>
  );
}

export default GeneralInformation;
